<template>
  <button
    type="button"
    class="icon-button"
    :class="[
      {
        'icon-button--small': size === 's',
        'icon-button--medium': size === 'm',
        'icon-button--large': size === 'l',
      },
    ]"
    v-bind="$attrs"
  >
    <slot>
      <Icon v-if="icon" :icon="icon" :size="iconSize" />
    </slot>
  </button>
</template>

<script setup lang="ts">
import Icon from '@atomic-ui/icon/Icon.vue';

withDefaults(
  defineProps<{
    icon?: object | string;
    size?: 's' | 'm' | 'l';
    iconSize?: string;
  }>(),
  {
    icon: undefined,
    size: 'm',
    iconSize: 'm',
  },
);
</script>




<style lang="scss" scoped>
@import '~settingSCSS';

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  padding: 0;
  background-color: $white;
  color: $black;
  transition: background-color 0.2s ease;
  width: rem-calc(32);
  height: rem-calc(32);

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &.icon-button--small {
    width: rem-calc(24);
    height: rem-calc(24);
  }

  &.icon-button--medium {
    width: rem-calc(32);
    height: rem-calc(32);
  }

  &.icon-button--large {
    width: rem-calc(40);
    height: rem-calc(40);
  }

  &.overlay {
    background: $white-overlay-color-2;
    animation-fill-mode: backwards;

    &:hover:not(:disabled) {
      background-color: $hover-color;
    }
  }
}


.icon-button {
  &.overlay {
    box-shadow: 0px 0px 4px 0px #00000040;
  }
}
</style>